<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <p>
          <b-button class="float-right" variant="link" @click="$parent.$emit('status', false)">Quick Setup Exit</b-button>
        </p>
      </b-col>
    </b-row>
    <b-card-group>
      <!-- .slideInDown
      .slideInLeft
      .slideInRight
      .slideInUp
      .slideOutDown
      .slideOutLeft
      .slideOutRight
      .slideOutUp -->
      <!-- 안내 -->
      <b-card v-if="step == 1" class="slideInDown slideOutDown">
        <b-row>
          <b-col class="text-center">
            <p class="title">
              Nice to meet you.
            </p>
            <p class="title">
              You've installed a new agent!
            </p>
            <p class="mt-3">
              * After initial setup, the settings can be changed at any time.
            </p>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 2" class="slideInDown slideOutDown">
        <!-- 설정 방법 -->
        <b-row>
          <b-col sm="12" class="text-center">
            <b-card-group deck style="cursor:pointer">
              <b-card bg-variant="primary" text-variant="info" header="Copy From Others policy" class="title" @click="list">
                <!-- title 이 필요 -->
                <!-- Copy settings to other servers -->
                <b-card-text>
                  <p>Apply different Web Firewall settings.</p>
                  <p>
                    [Select Agent] -> [Apply to other servers] -> [Apply]
                  </p>
                </b-card-text>
              </b-card>
              <b-card bg-variant="success" text-variant="success" header="Setup Policy" class="title" @click="next()">
                <!-- title 이 필요 -->
                <!-- Policy settings -->
                <b-card-text>
                  <p>Set it up quickly and operate in detection mode first.</p>
                  <p>Start setting up your web firewall.</p>
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 3" class="slideInLeft slideOutLeft">
        <b-row class="mb-3">
          <b-col>
            <p class="title">* Select the service you are using.</p>
          </b-col>
        </b-row>
        <!-- 룰 설정 -->
        <RuleService ref="RuleService" :quick_setting="setting" :ico="ico" @toggle_policy="toggle_policy"></RuleService>
        <b-form-group class="animated fadeIn fadeOut mt-3" style="cursor:pointer">
          <template #label>
            <p>
              <svg v-if="is_more" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-caret-down-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
              </svg>
              <svg v-else width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-caret-right-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
              </svg>
              <span @click="is_more = !is_more">More : is Default recommended</span>
            </p>
            <hr>
          </template>
          <ul v-if="is_more">
            <li>
              <b-form-checkbox stacked @change="toggle_all" v-model="all_selected" :indeterminate="all_indeterminate">  {{all_selected ? 'UnCheck' : 'Check'}} All
                <b-badge variant="success">{{summary_used_count || 0}}</b-badge>
              </b-form-checkbox>
            </li>
            <hr>
            <li
              v-for="(item, index) in policy_summary_list"
              v-bind:key="index"
              >
              <b-form-checkbox style="cursor:pointer;" :id="`check_${index}`" :indeterminate="item.indeterminate" v-model="item.use" stacked @change="toggle_one($event, item.value)"> {{item.text}}  </b-form-checkbox>
            </li>
          </ul>
        </b-form-group>
      </b-card>
      <b-card v-if="step == 4" class="slideInLeft slideOutLeft mr-4">
        <!-- 허용 아이피 설정 -->
        <RuleIP :origin="{ allow_ip : policy.allow_ip, block_ip : policy.block_ip }" @block_ip="($val, key) => policy.block_ip = $val" @allow_ip="($val, key) => policy.allow_ip = $val" :is_setup="true"></RuleIP>
      </b-card>
      <b-card v-if="step == 4" class="slideInLeft slideOutLeft">
        <!-- 경로 설정 -->
        <RuleCustom
          :origin="policy.path"
          name="path"
          :is_setup="true"
          example="/admin,/manager,/images"
          @update="($val, key) => policy.path = $val"
        ></RuleCustom>
      </b-card>
      <b-card v-if="step == 5" class="slideInLeft slideOutLeft">
        <!-- 운영 모드 및 레벨 확인 -->
        <RuleMode
          :setting="policy"
          :is_first="is_first"
          @update="($val, key) => policy[key] = $val"
        >
        </RuleMode>
      </b-card>
    </b-card-group>
    <!-- 스탭 공통 처리 부분 -->
    <p class="mt-4" v-if="step < all">
      <b-button v-if="step > 1" class="float-left" size="sm" variant="outline-info" @click="prev()"> Prev </b-button>
      <b-button v-if="step < all" class="float-right" size="sm" variant="primary" @click="next()">Next </b-button>
    </p>
    <p class="mt-4" v-else>
      <b-button v-if="step > 1" class="float-left" size="sm" variant="outline-info" @click="prev()"> Prev </b-button>
      <b-button v-if="step = all" class="float-right" size="sm" variant="outline-success" @click="modal_save = true">Save </b-button>
    </p>
    <b-row class="mt-4">
      <b-col>
        <center>{{step}} / {{all}}</center>
      </b-col>
    </b-row>
    <b-modal title="Policy Apply to agent(WAF)"  class="modal-success" v-model="modal_save" @ok="apply" ok-variant="outline-warning" header-bg-variant="warning" cancel-variant="outline-dark">
      Should apply the settings?
      <br>
      Detect mode allows you to check the detected logs without being blocked.
      <br>
      Settings can be changed at any time.
    </b-modal>
    <!-- 디버그 영역 -->
    <!-- {{policy}} -->
    <!-- {{policy_summary_list}} -->
    <!-- {{policy.rule}} -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
